import { StandardColumn } from './types'
import { ColumnsPreference } from '../../contexts/UserPreferencesContext'
import { getColumnLabel } from '../../constants/columnDictionary'

export function buildDefaultColumnsState<T>(columns: StandardColumn<T>[]): ColumnsPreference {
  return {
    order: columns.map((col) => col.id),
    hidden: columns.filter((col) => col.defaultHidden).map((col) => col.id),
  }
}

export function resolveColumnOrder<T>(columns: StandardColumn<T>[], state: ColumnsPreference): string[] {
  const ids = new Set(columns.map((col) => col.id))
  const childIds = new Set(columns.filter((col) => col.parentId).map((col) => col.id))
  const ordered = (state.order ?? []).filter((id) => ids.has(id) && !childIds.has(id))
  const missing = columns
    .filter((col) => !col.parentId)
    .map((col) => col.id)
    .filter((id) => !ordered.includes(id))
  const topLevelOrder = [...ordered, ...missing]
  return topLevelOrder.flatMap((id) => [
    id,
    ...columns.filter((col) => col.parentId === id).map((col) => col.id),
  ])
}

export function orderVisibleColumns<T>(columns: StandardColumn<T>[], state: ColumnsPreference): StandardColumn<T>[] {
  const byId = new Map(columns.map((col) => [col.id, col]))
  const hidden = new Set(state.hidden ?? [])
  return resolveColumnOrder(columns, state)
    .map((id) => byId.get(id)!)
    .filter((col) => !hidden.has(col.id))
}

export function resolveColumnLabel<T>(column: StandardColumn<T>): string {
  return column.label ?? getColumnLabel(column.id)
}
